import { zusToast } from '@zep/toast';
type VoucherAppliedToastCopy = {
  actionLabel: string;
  description: string;
  title: string;
};

/**
 * 이용권 적용 완료 토스트 (Figma 28913:51588 · 51593).
 *
 * 활성화 직후 플랜이 바뀐 사실만 알리고, 상세 확인은 플랜 관리로 넘긴다.
 * 시안이 모달이 아니라 토스트인 이유이기도 하다 — 하던 일을 끊지 않는다.
 *
 * 체크 아이콘·닫기 버튼·액션 버튼은 zusToast.success 가 기본으로 제공하므로
 * 여기서 다시 조립하지 않는다. `dismissible` 을 켜야 X 버튼이 나온다.
 *
 * 위치를 명시하는 이유: ZusToaster 기본이 bottom-center 라 그대로 두면 시안과 어긋난다.
 *
 * @param onOpenPlanManagement 「플랜 관리」 액션. 라우터를 토스트가 직접 들지 않도록 주입받는다.
 */
export const showVoucherAppliedToast = (onOpenPlanManagement: () => void, copy: VoucherAppliedToastCopy) => zusToast.success(copy.title, {
  description: copy.description,
  action: {
    label: copy.actionLabel,
    onClick: onOpenPlanManagement
  },
  position: 'top-center',
  dismissible: true
});